module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "padding-top": "1.2em",
      "padding-bottom": "0.8em"
    },
    attrs: {
      "align": "middle"
    }
  }, [_c('data-table', {
    ref: "equiptable",
    attrs: {
      "table-ref": "equiptable",
      "title": "Sites: Equipment",
      "icon": "fa fa-tools",
      "url": "/sites",
      "fields": _vm.fields,
      "sort-field": "siteName",
      "search-placeholder": "Site Ids, Site Names, Status, Site Group...",
      "detail-component": "site-equip-row"
    },
    scopedSlots: _vm._u([{
      key: "equip-details",
      fn: function(props) {
        return [_c('el-row', {
          attrs: {
            "gutter": 9.63
          }
        }, [_c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 24,
            "lg": 14,
            "hg": 14
          }
        }, [_c('site-card', {
          staticStyle: {
            "margin-top": "0.852em"
          },
          attrs: {
            "site-data": props.rowData,
            "use-leaflet": "",
            "map-left": "",
            "no-map": !_vm.isDesktop,
            "height": "230px"
          }
        })], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 24,
            "lg": 10,
            "hg": 10
          }
        }, [_c('el-card', {
          attrs: {
            "shadow": "hover"
          }
        }, [_c('good-table', {
          attrs: {
            "cols": _vm.getCols(props.rowData.stats),
            "rows": _vm.getRows(props.rowData.stats),
            "group": "",
            "fixed-header": "",
            "compact": "",
            "striped": "",
            "sort": false,
            "search": false,
            "pagination": false,
            "theme": "black-rhino",
            "max-height": "285px"
          }
        })], 1)], 1)], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01367b1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/EquipView.vue
// module id = 1297
// module chunks = 0